import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPost } from '../types';
import { formatDate } from '../utils/blogHelpers';

interface BlogListProps {
  posts: BlogPost[];
}

const BlogList: React.FC<BlogListProps> = ({ posts }) => {
  return (
    <main className="page-shell">
      <header className="page-title">
        <p className="eyebrow">Writing</p>
        <h1>Essays and notes</h1>
        <p>
          Longer thoughts on language, AI, healthcare, psychology, and the work
          of building useful systems.
        </p>
      </header>

      <div className="blog-index">
        {posts.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="blog-card"
          >
            {post.coverImage && (
              <div className="mb-6 overflow-hidden">
                <img
                  src={post.coverImage}
                  alt={post.title}
                  className="h-48 w-full object-cover"
                />
              </div>
            )}
            
            <time dateTime={post.date}>
              {formatDate(post.date)}
            </time>
            
            <h2>{post.title}</h2>
            
            <p>{post.description}</p>
            
            {post.tags && post.tags.length > 0 && (
              <div className="tag-line">
                {post.tags.map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </div>
            )}
          </Link>
        ))}
      </div>
    </main>
  );
};

export default BlogList; 
